import styled from 'styled-components'
import { Modal } from '@sketch/components'
import { CodeBlock as CodeBlockRaw } from '../CodeBlock'

export const ModalHeader = styled(Modal.Header)`
  && {
    padding: 16px;
  }
`

export const ModalBody = styled(Modal.Body)`
  && {
    padding: 0;
  }
`

export const CodeBlock = styled(CodeBlockRaw)`
  padding: 16px 20px;
  height: auto;
  max-height: 264px;
  overflow: auto;
  resize: none;
`
